var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero-slider" }, [
    _c("div", { ref: "slider", staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.data, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              ref: "slide",
              refInFor: true,
              staticClass: "hero-slide swiper-slide"
            },
            [
              item.type === "photo"
                ? _c("div", {
                    staticClass: "hero-slide__img swiper-lazy",
                    attrs: { "data-background": item.image }
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type === "video"
                ? _c(
                    "video",
                    {
                      ref: "video",
                      refInFor: true,
                      staticClass: "hero-slide__video",
                      attrs: { loop: "", muted: "", playsinline: "" },
                      domProps: { muted: true }
                    },
                    [
                      item.video.mp4
                        ? _c("source", {
                            staticClass: "swiper-lazy",
                            attrs: {
                              src: item.video.mp4,
                              "data-src": item.video.mp4,
                              type: "video/mp4"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.video.webm
                        ? _c("source", {
                            staticClass: "swiper-lazy",
                            attrs: {
                              src: item.video.webm,
                              "data-src": item.video.webm,
                              type: "video/webm"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.video.ogv
                        ? _c("source", {
                            staticClass: "swiper-lazy",
                            attrs: {
                              src: item.video.ogv,
                              "data-src": item.video.ogv,
                              type: "video/ogg"
                            }
                          })
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-lazy-preloader swiper-lazy-preloader-white"
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "hero-slide__info",
                  attrs: {
                    href: item.link,
                    "data-target": "ClickSlide" + (index + 1) + "MainPage",
                    "data-label": "slide" + (index + 1),
                    "data-category": "slider"
                  },
                  on: {
                    click: function($event) {
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      return _vm.targetAnalytics($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "container" }, [
                    item["general-news"]
                      ? _c("p", {
                          staticClass: "hero-slide__tag",
                          domProps: { innerHTML: _vm._s(_vm.text.caption) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "hero-slide__title",
                      domProps: { innerHTML: _vm._s(item.name) }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "hero-slide__text",
                      domProps: { innerHTML: _vm._s(item.detail) }
                    })
                  ])
                ]
              )
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { ref: "pagination", staticClass: "hero-slider__pagination" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            class: [
              "hero-slider-pagination",
              { "hero-slider-pagination--filled": !_vm.isAutoplay }
            ]
          },
          _vm._l(_vm.data, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                class: [
                  "hero-slider-pagination__item",
                  {
                    "hero-slider-pagination__item--active":
                      index === _vm.currentSlideIndex
                  }
                ],
                on: {
                  click: function($event) {
                    return _vm.changeSlide(index)
                  }
                }
              },
              [
                _vm._m(0, true),
                _vm._v(" "),
                _c("p", {
                  staticClass: "hero-slider-pagination__text",
                  domProps: { innerHTML: _vm._s(item.signature) }
                })
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "hero-slider-pagination hero-slider-pagination--mobile"
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero-slider-pagination__timer" }, [
      _c("span", { staticClass: "hero-slider-pagination__line" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e74b5dc2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e74b5dc2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/hero-slider/hero-slider.vue
// module id = 106
// module chunks = 0